import * as React from 'react';
import classnames from 'classnames';
import { getAsset, ICoreContext } from '@msdyn365-commerce/core';
import { IProductInventoryInformation } from '@msdyn365-commerce-modules/retail-actions';

export interface IAvailabilityProps {
    baseClassName: string;
    context: ICoreContext;
    availability?: IProductInventoryInformation;
}

export const Availability: React.FC<IAvailabilityProps> = ({ baseClassName, context, availability }) => {
    if (!availability) {
        return null;
    }

    let availabilityClass = 'not-available';
    let availabilityIcon = getAsset('icons/availability-special-order.svg', context.request);

    if (availability.StockLevelLabel?.startsWith('!') || availability.IsProductAvailable) {
        availabilityClass = 'available';
        availabilityIcon = getAsset('icons/availability-available.svg', context.request);
    }

    if (availability.StockLevelCode === 'ERR') {
        availabilityClass = 'error';
        availabilityIcon = getAsset('icons/availability-expired.svg', context.request);
    }

    const stockLevelLabel = availability?.StockLevelLabel?.startsWith('!')
        ? availability?.StockLevelLabel?.substring(1)
        : availability?.StockLevelLabel;
    const availabilityText = stockLevelLabel || (availabilityClass === 'error' ? 'ERROR' : '');

    return (
        <div className={classnames(`${baseClassName}__details__availability`, availabilityClass)}>
            <img className={`${baseClassName}__details__availability__icon`} src={availabilityIcon} />
            <span>
                {availabilityText}
            </span>
        </div>
    );
};
